import {createReducer, on} from "@ngrx/store";
import {FvSensitivityState, INITIAL_STATE} from "./fv-sensitivity.state";
import {FvSensitivityActions, FvSensitivityDetailsActions} from "./fv-sensitivity.actions";


export const fvSensitivityStoreFeatureKey = "valumize/fv-sensitivity";

export const fvSensitivityReducer = createReducer(
    INITIAL_STATE,
    on(
        FvSensitivityActions.clearState,
        (): FvSensitivityState => (INITIAL_STATE)),
    on(
        FvSensitivityActions.load,
        FvSensitivityActions.compute,
        (state): FvSensitivityState => ({
            ...state,
            fundValuationSensitivityOverview: {
                ...state.fundValuationSensitivityOverview,
                status: "LOADING",
                errorMessage: ""
            }
        })),
    on(
        FvSensitivityActions.loadSuccess,
        FvSensitivityActions.computeSuccess,
        (state, action): FvSensitivityState => ({
            ...state,
            fundValuationSensitivityOverview: {
                data: action.fundValuationSensitivityOverview,
                status: "LOADED",
                errorMessage: ""
            }
        })),
    on(
        FvSensitivityActions.loadError,
        FvSensitivityActions.computeError,
        (state, {errorMsg}): FvSensitivityState => ({
            ...state,
            fundValuationSensitivityOverview: {
                ...state.fundValuationSensitivityOverview,
                status: "ERROR",
                errorMessage: errorMsg
            }
        })),
    on(
        FvSensitivityDetailsActions.load,
        (state): FvSensitivityState => ({
            ...state,
            fundValuationSensitivity: {
                ...state.fundValuationSensitivity,
                status: "LOADING",
                errorMessage: ""
            }
        })),
    on(
        FvSensitivityDetailsActions.loadSuccess,
        (state, action): FvSensitivityState => ({
            ...state,
            fundValuationSensitivity: {
                data: action.fundValuationSensitivity,
                status: "LOADED",
                errorMessage: ""
            }
        })),
    on(
        FvSensitivityDetailsActions.loadError,
        (state, {errorMsg}): FvSensitivityState => ({
            ...state,
            fundValuationSensitivity: {
                ...state.fundValuationSensitivity,
                status: "ERROR",
                errorMessage: errorMsg
            }
        })),
    on(
        FvSensitivityActions.setColumnTokens,
        (state, {tokens}): FvSensitivityState => ({...state, selectedColumnTokens: tokens})
    )
);
